import { ActorFilterRegistryCategory } from '../ActorFilterRegistryCategory';
import { ActorFilterRegistryItem } from '../ActorFilterRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class ActorFilterByType extends ActorFilterRegistryCategory {
    label = 'By Actor Type';
    constructor(parent) {
        super(parent);
        [
            'topic',
            'path',
            'app',
            'stage',
            'cycle',
            'text',
            'gap',
            'box',
            'table',
            'video',
            'sound',
            'image',
            'question',
            'questionpart',
            'option',
            'readtask',
            'wordtask',
            'selecttask',
            'task',
            'step',
            'audio',
            'association',
            'reward',
            'sortablelist',
            'sortableitem',
            'manner',
        ].forEach((type) => {
            this[type] = () => new ActorFilterRegistryItem({ filter: ({ a }) => a.type === type });
        });
        super.init();
    }
    at = () => new ActorFilterRegistryItem({
        label: 'AttachedTrait',
        filter: ({ a }) => a instanceof runtime.class.AttachedTrait,
    });
}
